import {AppLangue} from "src/commun/AppTypes";
import {Account, ActiveService, MenuDto, PointMenuDto, User} from "src/domain/User";
import {Configuration} from "src/domain/Configuration";

import {Employeur} from "src/domain/Employeur";

export type Action =
    | { type: "setUser"; payload: User }
    | { type: "setServices"; payload: Account }
    | { type: "setMenuGauche"; payload: PointMenuDto[] }
    | { type: "setBai"; payload: ActiveService }
    | { type: "setCybersafe"; payload: ActiveService }
    | { type: "setFavoris"; payload: string[] }
    | { type: "setEmployeurs"; payload: Employeur[] }
    | { type: "setEmployeurContextuel"; payload: Employeur }
    | { type: "setLangue"; payload: AppLangue }
    | { type: "setTraductions"; payload: { [x: string]: string } }
    | { type: "setCguLink"; payload: string }
    | { type: "logout" }
    | { type: "setConfiguration"; payload: Configuration }
    | { type: "setMenu"; payload: MenuDto };

export type State = {
  user: User | undefined;
  services: Account | undefined;
  bai: ActiveService | undefined;
  cybersafe: ActiveService | undefined;
  menuGauche: PointMenuDto[] | undefined;
  favoris: string[] | undefined;
  employeurs: Employeur[] | undefined;
  employeurContextuel: Employeur | undefined;
  cguLink: string;
  langue: AppLangue;
  traductions: { [x: string]: string } | undefined;
  configuration: Configuration;
  menu: MenuDto | undefined;
};

export const initialState: State = {
  user: undefined,
  services: undefined,
  bai: undefined,
  cybersafe: undefined,
  menuGauche: undefined,
  favoris: undefined,
  employeurs: undefined,
  employeurContextuel: undefined,
  cguLink: "",
  langue: "fr",
  traductions: undefined,
  configuration: {
    codeDelaiValidite: "5",
    displayLogoFer: true,
    footerConditionsGeneralesUrl: "",
    footerFaqUrl: "",
    footerContactUrl: "",
    logoutUrl: "",
    footerTextMilieuFr: "",
    footerTextMilieuDe: "",
    footerTextMilieuEn: "",
    activeFavori: true,
    urlMessagerieAvs: "",
    urlMessageriePp: "",
    urlAnalytics: "",
  },
  menu: undefined,
};

export function stateReducer(prevState: State, action: Action): State {
  switch (action.type) {
    case "setUser": {
      return {
        ...prevState,
        user: action.payload,
      };
    }
    case "setServices": {
      return {
        ...prevState,
        services: action.payload,
      };
    }
    case "setBai": {
      return {
        ...prevState,
        bai: action.payload,
      };
    }
    case "setCybersafe": {
      return {
        ...prevState,
        cybersafe: action.payload,
      };
    }
    case "setMenuGauche": {
      return {
        ...prevState,
        menuGauche: action.payload,
      };
    }
    case "setFavoris": {
      return {
        ...prevState,
        favoris: action.payload,
      };
    }
    case "setEmployeurs": {
      return {
        ...prevState,
        employeurs: action.payload,
      };
    }
    case "setEmployeurContextuel": {
      return {
        ...prevState,
        employeurContextuel: action.payload,
      };
    }
    case "setLangue": {
      return {
        ...prevState,
        langue: action.payload,
      };
    }
    case "setTraductions": {
      return {
        ...prevState,
        traductions: action.payload,
      };
    }
    case "setCguLink": {
      return {
        ...prevState,
        cguLink: action.payload,
      };
    }
    case "setConfiguration": {
      return {
        ...prevState,
        configuration: action.payload,
      };
    }
    case "setMenu": {
      return {
        ...prevState,
        menu: action.payload,
      };
    }
    case "logout":
      return initialState;
    default: {
      return prevState;
    }
  }
}
